import { useState, useEffect } from 'react'
import { isEqual } from 'lodash'

const useFilterState = (values, filterProps) => {
  const isFilterEqual = (a, b) => isEqual(new Set(a), new Set(b))

  const [filterValues, setFilterValues] = useState(values)
  const [changed, setChanged] = useState(new Set())
  const [filterCount, setFilterCount] = useState()

  useEffect(() => {
    const countFilters = () =>
      Object.keys(values).reduce(
        (count, key) =>
          filterProps.includes(key) && !!values[key] ? count + 1 : count,
        0
      )

    setFilterValues(values)
    setChanged(new Set())
    setFilterCount(countFilters())
  }, [values, filterProps])

  const handleChange = ({ name, value }) => {
    /* eslint-disable */
    isFilterEqual(values[name], value)
      ? setChanged(current => {
        current.delete(name)
        return current
      })
      : setChanged(current => current.add(name))
    setFilterValues({ ...filterValues, [name]: value })
    /* eslint-enable */
  }

  return { handleChange, changed, filterValues, filterCount }
}

export default useFilterState
